import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import PostPreview from "./PostPreview";

const PostPreviewModal = ({ onClose, ...rest }) => {
  const { t } = useTranslation(["planner"]);

  return (
    <Modal
      autoFocus={false}
      returnFocusOnClose={false}
      isOpen
      onClose={onClose}
      size="2xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("post_preview.modal_title")}</ModalHeader>
        <ModalBody>
          <PostPreview {...rest} />
        </ModalBody>
        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
};

PostPreviewModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

PostPreviewModal.defaultProps = {};

export default PostPreviewModal;
